import { useState } from 'react';
import {
    Wrapper,
    RequestDemoButton,
    RequestDemoButtonWrapper,
    Heading,
    SubHeading,
} from './styles';
import dynamic from 'next/dynamic';

const RequestDemoModal = dynamic(() => import('../requestModal'));

const Footer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <Wrapper>
            <Heading>Ready to get started?</Heading>
            <SubHeading>
                Whether you&rsquo;re just getting started with insurance or are
                looking to enhance existing offerings, ACKO has opportunities
                for you to get to market rapidly and effectively.
            </SubHeading>
            <RequestDemoButtonWrapper>
                <RequestDemoButton onClick={() => setIsModalOpen(true)}>
                    Request a demo
                </RequestDemoButton>
            </RequestDemoButtonWrapper>
            {isModalOpen && (
                <RequestDemoModal
                    popupStatus={isModalOpen}
                    onClose={setIsModalOpen}
                />
            )}
        </Wrapper>
    );
};

export default Footer;
